import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import {usePermissions} from '@dms/shared';

/**
 * Single gate for every click-to-call entry point, so the Call button and the top-bar indicator
 * appear identically: the `core_telephony` feature flag plus the `TELEPHONY_CALL` permission.
 * Whether the tenant can actually place calls (licence, Twilio setup, a line with a number, the
 * caller's mobile) is answered by `GET /telephony/call-options` inside the Call dialog, which needs
 * only that same permission; the settings-only Twilio account endpoint is deliberately not used.
 */
export function useTelephonyCallAvailability() {
  const isFlagEnabled = isFeatureEnabled(featureFlags.CORE_TELEPHONY);
  const [canStartCall] = usePermissions({permissionKeys: ['telephonyCallStart']});

  return {isAllowed: isFlagEnabled && canStartCall};
}
